'use client';

import { cn } from '@packages/shared/src/utils/cn/cn';
import { useEffect, useState } from 'react';

export const DevTool = () => {
  const [show, setShow] = useState(true);
  const [isHydrated, setIsHydrated] = useState(false);
  const [tbt, setTbt] = useState<number | null>(null);
  const [longTasks, setLongTasks] = useState<PerformanceEntry[]>([]);

  // Mark hydration complete
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Measure TBT during hydration
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
      // Set start time to navigation start
      // const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      // setStartTime(navEntry.startTime);

      // Observe long tasks
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        setLongTasks((prev) => [...prev, ...entries]);

        // Calculate TBT
        let totalBlockingTime = 0;
        entries.forEach((entry) => {
          // Only count blocking time over 50ms threshold
          const blockingTime = Math.max(0, entry.duration - 50);
          totalBlockingTime += blockingTime;
        });

        setTbt((prev) => (prev || 0) + totalBlockingTime);
      });

      observer.observe({ entryTypes: ['longtask'] });

      return () => observer.disconnect();
    }
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className="bg-color-grey-light fixed right-4 top-4 z-50 rounded shadow-md">
      {/* <div className="px-4 py-2">HYDRATED: {isHydrated}</div>
      <div className="px-4 py-2">STARTTIME: {startTime}</div>
      <div className="rounded border p-4">
        <h3 className="mb-2 font-medium">Long Tasks ({longTasks.length})</h3>
        <div className="max-h-40 overflow-y-auto">
          {longTasks.map((task, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i} className="mb-1 font-mono text-sm">
              {`Task ${i + 1}: ${task.duration.toFixed(2)}ms (${task.startTime.toFixed(0)}ms - ${(task.startTime + task.duration).toFixed(0)}ms)`}
            </div>
          ))}
        </div>
      </div> */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className={cn('rounded border-2 p-1', { 'border-color-additional': isHydrated })}
        onClick={() => setShow(false)}
      >
        <h4 className="mb-2 font-bold">TBT</h4>
        <p className="text-color-additional font-mono text-xl font-bold">
          {tbt !== null ? `${tbt.toFixed(2)}ms` : 'Measuring...'}
        </p>
        <p className="text-size-body3 text-color-sale font-bold">LONG TASKS: {longTasks.length}</p>
      </div>
    </div>
  );
};
